import { useEffect, useState } from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import ActionButton from '../../../../../../component/table/component/tablebody/component/ActionButton.component';
// import TablePaginationComponent from '../../../../../../component/table/component/pagination/TablePagination.component';
import { PaperComponent } from '../../../../../../component/table/component/Table';
import { HEAD_CELL } from '../../utils/HEAD_CELL';
import { FormInput } from '../../../../../../component/input/InputStyle';
import ButtonComponent from '../../../../../../component/buttton/Button.component';
import { ForecastDTO } from '../../Interface/DeliveryInterface';
import { setDeliveryForecast } from '../../PationManagement.service';
import { useSnackbar } from '../../../../../../context/Snackbar';
import Loader from '../../../../../../component/Loader/LoaderComponent';
import { useStore } from '../../../../../../context/Store';
import { useManagement } from '../../../../../../context/Management';

export const TableComponent = (props: any) => {
  const { data } = props
  const { setSnackbar } = useSnackbar();

  const { setFlag, setStore, flag, store, setSelectedStore } = useStore();
  const { valueCd } = useManagement();

  const [tableAux, setTableAux] = useState(data)
  const [loading, setLoading] = useState(false);

  const handleChange = (event: any, index: any) => {
    const { value, name } = event.target

    if (name === 'initialHour') {
      let aux = [...tableAux]
      aux[index].Iniciar = value;
      setTableAux(aux);
    } else {
      let aux = [...tableAux]
      aux[index].Finalizar = value;
      setTableAux(aux);
    }
  }

  const handleSubmit = async (index: number) => {
    setLoading(true)
    let aux = [...tableAux];

    if (aux[index].Iniciar !== '' || aux[index].Iniciar !== '00:00:00') {
      const data = {
        veiculo: aux[index].Veiculo,
        StatusVeiculo: aux[index].StatusVeiculo,
        Pallets: parseInt(aux[index].Paletes),
        DataHoraExpedicao: aux[index].DataHoraExpedicao,
        Iniciar: aux[index].Iniciar === '00:00:00' ? null : aux[index].Iniciar,
        Finalizar: aux[index].Finalizar === '00:00:00' ? null : aux[index].Finalizar,
        cd: valueCd,
        destino: store
      }
      try {
        await setDeliveryForecast(data)
        if (data.Finalizar !== '' || data.Finalizar !== '00:00:00') {
          aux[index].Edit = true;
          setTableAux(aux);
        }
        setSnackbar({ msg: 'Dados salvos com sucesso.', subMsg: '', type: 'success' })
        setLoading(false)
      } catch (e) {
        setLoading(false);
        setSnackbar({ msg: 'Erro na comunição com a API.', subMsg: 'Não foi possível salvar os dados.', type: 'error' })
      }
    }
  }

  return (
    <>
      {loading ? <Loader /> :
        <PaperComponent>
          <Table aria-labelledby="tableTitle" aria-label="enhanced table" stickyHeader  >
            <TableHead>
              <TableRow>
                {HEAD_CELL.map((headCell) => (
                  <TableCell key={headCell.id} align={headCell.align || 'center'}>
                    {headCell.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item: ForecastDTO, index: number) => (
                <TableRow key={index}>
                  <TableCell align="center">{item.Veiculo}</TableCell>
                  <TableCell align="center">{item.StatusVeiculo}</TableCell>
                  <TableCell align="center">{item.Paletes}</TableCell>
                  <TableCell align="center">
                    <FormInput
                      disabled={tableAux[index].Edit}
                      type="time"
                      value={tableAux[index].Iniciar}
                      name="initialHour"
                      onChange={(event: any) => handleChange(event, index)} />
                  </TableCell>
                  <TableCell align="center">
                    <FormInput
                      disabled={tableAux[index].Edit || !tableAux[index].Iniciar}
                      type="time"
                      value={tableAux[index].Finalizar}
                      name="finalHour"
                      onChange={(event: any) => handleChange(event, index)} />
                  </TableCell>
                  <TableCell align="center">
                    <ButtonComponent NoReload={true} disabled={tableAux[index].Edit} title={'Gravar'} sizeFont='16px' size='small' onClick={() => handleSubmit(index)} type='submit' />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </PaperComponent>
      }
    </>
  )
}
